import { Form } from "react-bootstrap";

import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { handleFileInput } from "../choosePhotoWidget";
import { FormControlWrapper } from "./formControlWrapper";

export const FieldFileAttachments = ({
	isDisabled,
	// isForced = false,
	error,
	fieldData,
	placeholder = "",
	title = "",
	maxLength,
	autoFocus,
	tooltip,
	setValue = () => {},
}) => {
	const removeAttachment = (index) => {
		fieldData.splice(index, 1);
		setValue(fieldData);
	};

	return (
		<>
			<FormControlWrapper
				title={title}
				tooltip={tooltip}
				data-testid="test-fieldTextArea"
				error={error}
			>
				<Form.Control
					// value={isForced ? fieldData : undefined}
					data-testid="test-fieldTextAreaControl"
					disabled={isDisabled}
					type="file"
					defaultValue={fieldData || ""}
					placeholder={placeholder}
					maxLength={maxLength}
					isInvalid={!!error}
					autoFocus={autoFocus}
					onChange={async (e) => {
						const blob = (
							await handleFileInput({
								// 20mb
								sizeLimit: 20971520,
							})(e)
						).split(",")[1];
						const fileName = e.target.files[0]?.name;
						if (!blob) return;
						if (fieldData === undefined) fieldData = [];

						fieldData.push({ fileName, blob });
						setValue(fieldData);
						// setValue(e.target.value);
					}}
				/>
			</FormControlWrapper>
			<ul>
				{fieldData?.map((d, key) => {
					return (
						<li key={key}>
							{d.fileName}{" "}
							<button className="btn btn-sm">
								<FontAwesomeIcon
									icon={faMultiply}
									onClick={() => removeAttachment(key)}
								/>
							</button>
						</li>
					);
				})}
			</ul>
		</>
	);
};
